import React, { useEffect, useState } from 'react';

import { Box, Flex, Spinner } from '@chakra-ui/react';
import { useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { REVIEW_CYCLE_STEPS_METADATA, useReviewCreationData } from 'reducers/reviewCreationSlice';
import { sidebarNavIsExpandedSelector } from 'selectors/sidebarNav';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { ArrowLeft, Publish } from 'assets/assetsV1/iconComponents';

import { goToReviewProcess } from 'constants/helper';

import { Button } from 'uiToolkitV1/Button';

import { useSaveReviewCycle } from '../../Hooks/dataHooks/summaryDataHooks';
import { useReviewCreationNavigation } from '../../Hooks/useReviewCreationNavigation';
import { getPrevStep } from '../../ReviewCreationFooter';
import { Calibration } from './Calibration';
import { Elements } from './Elements';
import { FormFillingExperience } from './FormFillingExperience';
import { ReviewDetails } from './ReviewDetails';
import { Reviewees } from './Reviewees';
import { Reviewers } from './Reviewers';
import { ShareResults } from './ShareResults';

const Footer = () => {
  const { goToPrevStep } = useReviewCreationNavigation();
  const history = useHistory();

  const { mutate, isLoading } = useSaveReviewCycle();
  const handleContinue = () => {
    mutate();
  };

  const handleClose = () => {
    goToReviewProcess(history);
  };

  const isExpandedState = useSelector(sidebarNavIsExpandedSelector);
  const { isDraft, isPublished, currentStage, step } = useReviewCreationData();
  const prevStep = getPrevStep({ currentStep: step, currentStage });
  const isL2NavVisible = useSelectIsL2Visible();

  const leftRabbitUI = isExpandedState ? '242px' : '16px';
  const leftDeerUI = isL2NavVisible ? '320px' : '80px';

  return (
    <Box
      position="fixed"
      bottom={0}
      left={checkNewNavEnabled() ? leftDeerUI : leftRabbitUI}
      right={0}
      transition="left 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    >
      <Flex
        p={4}
        alignItems="center"
        bg="rgba(245, 247, 249, 0.9)"
        boxShadow="0px -1px 0px #CFD7DF"
        justifyContent="space-between"
      >
        <Box>
          {!isPublished && (
            <Button variant="tertiary" StartIcon={() => <ArrowLeft boxSize="24px" />} onClick={goToPrevStep}>
              Back To {prevStep ? REVIEW_CYCLE_STEPS_METADATA[prevStep]?.title : ''}
            </Button>
          )}
        </Box>
        <Box>
          {isDraft && !isLoading && (
            <Button ml="auto" StartIcon={Publish} onClick={handleContinue}>
              Launch Review Cycle
            </Button>
          )}
          {isDraft && isLoading && (
            <Button ml="auto" isDisabled={isLoading}>
              <Flex alignItems="center" gap="8px">
                <Spinner size="sm" color="white" />
                Creating Review Cycle
              </Flex>
            </Button>
          )}
          {!isDraft && (
            <Button ml="auto" onClick={handleClose}>
              Close
            </Button>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export const Summary = () => {
  const [display, setDisplay] = useState('visible');

  // used to reset the component scroll position
  useEffect(() => {
    setDisplay('none');
    setTimeout(() => {
      setDisplay('visible');
    }, 0);
  }, []);

  if (display !== 'visible') return null;

  return (
    <>
      <ReviewDetails />
      <Reviewees />
      <Reviewers />
      <Elements />
      <FormFillingExperience />
      <Calibration />
      <ShareResults />
      <Footer />
    </>
  );
};
